const fragmentShader = `
uniform sampler2D noiseMap;

uniform vec3 colorA;
uniform vec3 colorB;
uniform float time;
uniform float strength;
uniform float noiseScaleA;
uniform float noiseScaleB;
uniform float opacity;

varying vec2 vUv;

const float NOISE_GRANULARITY = 0.5 / 255.0;

float random(vec2 coords) {

   return fract( sin( dot( coords.xy, vec2( 12.9898, 78.233 ) ) ) * 43758.5453 );

}

void main() {

  float n1 = texture2D( noiseMap, ( (vUv * noiseScaleA) + ( time * 0.04 ) ) ).r;
  float n2 = texture2D( noiseMap, ( (vUv * noiseScaleB) - ( time * 0.03 ) ) ).r;

  float m = 1.0 - smoothstep( 0.0, 0.5, distance( vUv, vec2( 0.5 ) ) );

  m *= n1;

  float n = mix( n1, n2, 0.5 );

  gl_FragColor = vec4( vec3( mix( colorA, colorB, n ) ) * strength, m * opacity );
  gl_FragColor += mix(-NOISE_GRANULARITY, NOISE_GRANULARITY, random(vUv));

}`;

export default fragmentShader;
